import { render } from "./Pagination.vue?vue&type=template&id=4fdb4ed6&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=4fdb4ed6&lang=css"
import "./Pagination.vue?vue&type=style&index=1&id=4fdb4ed6&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdb4ed6"]])

export default __exports__